import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseEntityComponent, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import moment from "moment";
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { MensagemService } from 'src/app/features/mensagem.service';
import { JanelaApuracaoTaxaMediaMaximaAgente } from 'src/app/model/janela-apuracao-taxa-media-maxima-agente';
import { Tranche } from 'src/app/model/tranche.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { JanelaApuracaoService } from 'src/app/shared/services/janela-apuracao.service';
import { TrancheService } from 'src/app/shared/services/tranche.service';

@Component({
    selector: 'app-janelas-apuracao-cadastro',
    templateUrl: './janelas-apuracao-cadastro.component.html',
    standalone: false
})
export class JanelasApuracaoCadastroComponent extends BaseEntityComponent<JanelaApuracaoTaxaMediaMaximaAgente> implements OnInit {

  //valores formulario
  private ideTranche: number;
  private dataInicioJanela: Date;
  private dataFimJanela: Date;
  private dataFimExecucao: Date;
  private dataUltimaExecucao: Date;
  private usuarioResponsavel: string;
  private dataCriacao: Date;

  private dataFimJanelaValidacao: Date = null;
  private dataInicioJanelaValidacao: Date = null;

  private formJanela: UntypedFormGroup;

  private permissaoEdicao: Boolean;

  private podeEditarTudo: Boolean = false;

  private dataHoje = this.datePipe.transform(Date.now(), 'yyyyMMdd');

  private tranches: Tranche[];
  private vc: BnConfirmDirective;

  constructor(
    protected injector: Injector,
    private janelaService: JanelaApuracaoService,
    private permissaoService: PermissaoService,
    private loadingService: BnLoadingService,
    private datePipe: DatePipe,
    private modalService: BnModalMessageService,
    private mensagemService: MensagemService,
    private bnAlertsService: BnAlertsService,
    private trancheService: TrancheService,
   
  ) {
    super(janelaService);
    this.formJanela = this.createReactiveForm();
  }


  ngOnInit(): void {
    this.trancheService.getTranches().subscribe(cestas => {
      this.tranches = cestas;
    })

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.permissaoEdicao = resp && resp[ROLE_GESTOR_ENVIO];
      this.preparaModelo().subscribe((janela) => {
        this.preencheForm(janela);
        this.setModel(janela);
        this.loadingService.liberaTela();
        if (this.modoEdicao) this.podeEditarTudo = true;
      });
    }, (error) => {
      this.loadingService.liberaTela();
    });
    this.validarDatasFormulario();
  }

  public createReactiveForm() : FormGroup {
    const f  = this.formBuilder.group({
      ideTranche: ['', Validators.required],
      dataInicioJanela: [new Date(), Validators.required],
      dataFimJanela: [new Date(), Validators.required],
      dataFimExecucao: [new Date(), Validators.required],
      dataUltimaExecucao: [{value: new Date(), disabled: true} ],
      dataCriacao: [{value: new Date(), disabled: true}],
      usuarioResponsavel: [{value: '', disabled: true}]
    });

    return f;
  }

  public validarDatasFormulario() : void{
    const dataInicioJanela = this.formJanela.get("dataInicioJanela");
    const dataFimJanela = this.formJanela.get("dataFimJanela");
    const dataFimExecucao = this.formJanela.get("dataFimExecucao");

    dataFimJanela.valueChanges.subscribe(() => {
      if ((dataFimJanela.value instanceof Object)) {
        this.dataFimJanelaValidacao = new Date(dataFimJanela.value);
        this.dataFimJanelaValidacao.setDate(dataFimJanela.value.getDate() + 1);

        if ((dataFimExecucao.value instanceof Object) && this.compararDatas(dataFimJanela.value, dataFimExecucao.value)) {
          this.formJanela.get("dataFimExecucao").setErrors({ min: { min: this.datePipe.transform(this.dataFimJanelaValidacao, 'dd/MM/yyyy') } });
        }
      }
    });

    dataInicioJanela.valueChanges.subscribe(() => {
      if ((dataInicioJanela.value instanceof Object)) {
        this.dataInicioJanelaValidacao = new Date(dataInicioJanela.value);
        this.dataInicioJanelaValidacao.setDate(dataInicioJanela.value.getDate() + 1);

        if ((dataFimJanela.value instanceof Object) && this.compararDatas(dataInicioJanela.value, dataFimJanela.value)) {
          this.formJanela.get("dataFimJanela").setErrors({ min: { min: this.datePipe.transform(this.dataInicioJanelaValidacao, 'dd/MM/yyyy') } });
        }

      }
    });
  }

  compararDatas(dataMaior: Date, dataMenor: Date) : boolean{
    if(this.datePipe.transform(dataMaior, 'yyyyMMdd') >= this.datePipe.transform(dataMenor,'yyyyMMdd')){
      return true;
    }
    return false;
  }


  verificarVoltaParaLista() : void {
    if (!this.formJanela.pristine) {
      this.verificaSePodeSair().then(resposta => {
        if (resposta === true) {
          this.formJanela.reset();
          this.voltarParaLista();
        }
      });
    } else {
      this.formJanela.reset();
      this.voltarParaLista();
    }

  }

  voltarParaLista() : void {
    this.router.navigate(['janelas-apuracao/pesquisa']);
  }

  public preparaModelo(): Observable<JanelaApuracaoTaxaMediaMaximaAgente> {
    return this.route.params.pipe(
      mergeMap((params) => {
        if (params['id']) {
          return this.janelaService.findById(params['id']);
        } else {
          const novo = new JanelaApuracaoTaxaMediaMaximaAgente();
          super.editar();
          return of(novo);
        }
      })
    );
  }

  preencheForm(janela: JanelaApuracaoTaxaMediaMaximaAgente) : void {
    this.formJanela.patchValue({
      ideTranche: janela.ideTranche,
      dataInicioJanela: janela.dataInicioJanela == null ? null : moment(janela.dataInicioJanela).toDate(),
      dataFimJanela: janela.dataFimJanela == null ? null : moment(janela.dataFimJanela).toDate(),
      dataFimExecucao: janela.dataFimExecucao == null ? null : moment(janela.dataFimExecucao).toDate(),
      dataUltimaExecucao: janela.dataUltimaExecucao == null ? null : moment(janela.dataUltimaExecucao).toDate(),
      dataCriacao: janela.dataCriacao == null ? null : moment(janela.dataCriacao).toDate(),
      usuarioResponsavel: janela.usuarioResponsavel,
    });

  }

  atualizaModel() : void {
    this.model.ideTranche = this.formJanela.get("ideTranche").value;
    this.model.dataInicioJanela = this.formJanela.get("dataInicioJanela").value;
    this.model.dataFimJanela = this.formJanela.get("dataFimJanela").value;
    this.model.dataFimExecucao = this.formJanela.get("dataFimExecucao").value;
  }


  salvar() : void {
    this.atualizaModel();
    console.debug("model: " + JSON.stringify(this.model));
    this.abreModalConfirmacao(this.model.id != null ?
      'Deseja confirmar a alteração dos dados da janela?' : 'Deseja confirmar o cadastro da janela?')
      .then(resp => {
        if (resp === true) {
          this.loadingService.bloqueiaTela();
          const acao = this.model.id != null ?
            this.janelaService.atualizarJanela(this.model.id, this.model) : this.janelaService.salvarJanelaApuracao(this.model);
          acao.subscribe(
            janelaRetornada => {
              this.model.id != null ? this.mensagemService.adicionarMensagemSucesso("Janela de Apuração atualizada com sucesso.") : this.mensagemService.adicionarMensagemSucesso("Janela de Apuração cadastrada com sucesso.")
              this.model = janelaRetornada;
              this.loadingService.liberaTela();
              this.aposSalvar();
              this.voltarParaLista();
            },
            error => {
              this.loadingService.liberaTela();
            }
          )
        }
      })
  }

  async abreModalConfirmacao(mensagem: string): Promise<boolean> {
    const titulo = 'Confirmação';

    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  habilitarEdicao() : void {
    this.validarEdicao();
    if (this.podeEditarTudo) this.formJanela.get("ideTranche").enable();
    if (this.podeEditarTudo) this.formJanela.get("dataInicioJanela").enable();
    this.formJanela.get("dataFimJanela").enable();
    this.formJanela.get("dataFimExecucao").enable();
    
    this.formJanela.get("usuarioResponsavel").disable();
    this.formJanela.get("dataCriacao").disable();
    this.formJanela.get("dataUltimaExecucao").disable();
    super.editar();
  }
  validarEdicao(): void {
    if (this.dataHoje < this.datePipe.transform(this.model.dataInicioJanela, 'yyyyMMdd')) this.podeEditarTudo = true;
  }

  async verificaSePodeSair(): Promise<boolean> {
    const titulo = 'Confirmação';
    const mensagem = this.model.id != null ? 'Descartar alterações realizadas na janela?' : 'Descartar novo cadastro de janela?';
    try {
      const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
      return resultadoConfimacao.value === 'ok';
    } catch (e) {
      return false;
    }
  }

  recuperarNumeroTranche(ideTranche: number): number {
    return this.tranches.find(tranche => tranche.id == ideTranche).numeroTranche;
  }

}
